@if (menuPoint(); as menuPoint) {
	@if (isLink()) {
		<a
			class="flex items-center flex-col hover:bg-primary-300 justify-center duration-300 cursor-pointer h-14.5 outline-none focus-visible-border focus-visible:rounded-sm border-2 border-transparent w-full"
			[class]="{
				'bg-primary-200': isActive(),
				'bg-primary-300!': isHovered(),
			}"
			[routerLink]="menuPoint.url"
			[attr.data-id]="menuPoint.url"
			[uiTooltip]="menuPoint.description ?? ''"
			[tooltipPosition]="menuPoint.tooltipPosition ?? 'right'"
		>
			<ng-container [ngTemplateOutlet]="entryContent"></ng-container>
		</a>
	} @else {
		<button
			class="flex items-center flex-col hover:bg-primary-300 justify-center duration-300 cursor-pointer h-14.5 outline-none focus-visible-border focus-visible:rounded-sm border-2 border-transparent w-full"
			[class]="{
				'bg-primary-200': isActive(),
				'bg-primary-300!': isHovered(),
			}"
			[attr.data-id]="menuPoint.url"
			[uiTooltip]="menuPoint.description ?? ''"
			[tooltipPosition]="menuPoint.tooltipPosition ?? 'right'"
		>
			<ng-container [ngTemplateOutlet]="entryContent"></ng-container>
		</button>
	}
}

<ng-template #entryContent>
	<ui-icon size="l" [type]="navColor()" [icon]="menuPoint()?.icon"> </ui-icon>
	<span
		class="text-[0.625rem] leading-none mt-1 text-center whitespace-normal hyphens-auto break-words"
		[attr.lang]="lang()"
		[class]="{
			'text-secondary-800': navColor() === 'dark',
			'text-primary-700': navColor() === 'primary',
			'text-white': navColor() === 'light',
		}"
	>
		{{ menuPoint()?.name ?? '' }}
	</span>
</ng-template>
